// Example prompting the user with a dialog
import '@banno/jha-wc/src/jha-dialog/jha-dialog.js';
import DialogUtil, { DialogConfig } from '@banno/jha-wc/src/js/utils/dialog-util.js';

export const checkLookupDrawer = async (config: DialogConfig) => {
    try {
        const dialogResponse = await DialogUtil.awaitDialog(config);
        console.log('Confirmed!', dialogResponse, config);
    } catch (error) {
        console.log('Canceled!');
    }
};
